import { ArrowDownRight, Zap, Flame, Snowflake } from "lucide-react";

const PRODUCT_IMG =
    "https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/g18t6msx_1000073436.png";
const BULL_LOGO =
    "https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/35o1dtom_ChatGPT%20Image%2020.%206.%202026%2C%2009_50_18.png";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 px-6 sm:px-10 grain overflow-hidden"
        >
            {/* Red radial glow */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute top-1/2 right-[5%] -translate-y-1/2 w-[640px] h-[640px] rounded-full"
                style={{
                    background:
                        "radial-gradient(circle, rgba(217,28,28,0.35) 0%, rgba(217,28,28,0.08) 40%, transparent 70%)",
                    filter: "blur(20px)",
                }}
            />

            {/* Bull logo ghost watermark */}
            <img
                src={BULL_LOGO}
                alt=""
                aria-hidden="true"
                className="absolute -left-32 top-32 w-[640px] opacity-[0.04] pointer-events-none select-none"
            />

            <div className="relative max-w-[1400px] mx-auto z-10">
                {/* Overline + badge */}
                <div className="fade-up flex flex-wrap items-center gap-4 mb-8">
                    <div
                        data-testid="hero-overline"
                        className="flex items-center gap-3 text-[#D91C1C] text-xs uppercase tracking-[0.3em]"
                    >
                        <span className="h-px w-10 bg-[#D91C1C]" />
                        Domáce · Jeden Nápoj · Bez Výhovoriek
                    </div>
                    <span
                        data-testid="hero-scarcity-badge"
                        className="inline-flex items-center gap-2 bg-[#D91C1C]/15 border border-[#D91C1C]/40 text-[#FF4D4D] px-3 py-1.5 text-[10px] uppercase tracking-[0.25em] font-semibold"
                    >
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D91C1C] opacity-75" />
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#D91C1C]" />
                        </span>
                        Vydanie nie je isté
                    </span>
                </div>

                {/* Grid: massive type + product image */}
                <div className="grid grid-cols-12 gap-6 sm:gap-10 items-center">
                    {/* Left: massive MAD type */}
                    <div className="col-span-12 lg:col-span-7 fade-up">
                        <h1
                            data-testid="hero-heading"
                            className="font-display uppercase leading-[0.82] tracking-tighter text-white text-[22vw] sm:text-[18vw] lg:text-[14rem] xl:text-[17rem]"
                            style={{
                                textShadow:
                                    "0 0 60px rgba(217,28,28,0.25), 0 0 120px rgba(217,28,28,0.15)",
                            }}
                        >
                            M<span className="text-[#D91C1C]">A</span>D
                        </h1>

                        <p
                            data-testid="hero-tagline"
                            className="mt-6 max-w-xl text-lg sm:text-2xl text-white/80 leading-relaxed"
                        >
                            Domáci kultový nápoj. Surový, šumivý a&nbsp;trochu
                            nahnevaný. <span className="text-white">Pre tých, čo nepijú nudu.</span>
                        </p>

                        {/* Mini energy stats */}
                        <div className="mt-8 grid grid-cols-3 max-w-md gap-px bg-white/10 border border-white/10">
                            <div
                                data-testid="energy-stat-caffeine"
                                className="bg-[#0A0A0A] p-4 flex flex-col items-start"
                            >
                                <Zap
                                    size={18}
                                    className="text-[#D91C1C] mb-2"
                                    strokeWidth={1.5}
                                />
                                <div className="font-display text-2xl text-white leading-none">
                                    0
                                </div>
                                <div className="text-[9px] uppercase tracking-[0.2em] text-white/50 mt-1">
                                    mg kofeínu
                                </div>
                            </div>
                            <div
                                data-testid="energy-stat-heat"
                                className="bg-[#0A0A0A] p-4 flex flex-col items-start"
                            >
                                <Flame
                                    size={18}
                                    className="text-[#D91C1C] mb-2"
                                    strokeWidth={1.5}
                                />
                                <div className="font-display text-2xl text-white leading-none">
                                    11/10
                                </div>
                                <div className="text-[9px] uppercase tracking-[0.2em] text-white/50 mt-1">
                                    chuť
                                </div>
                            </div>
                            <div
                                data-testid="energy-stat-cold"
                                className="bg-[#0A0A0A] p-4 flex flex-col items-start"
                            >
                                <Snowflake
                                    size={18}
                                    className="text-[#D91C1C] mb-2"
                                    strokeWidth={1.5}
                                />
                                <div className="font-display text-2xl text-white leading-none">
                                    4°C
                                </div>
                                <div className="text-[9px] uppercase tracking-[0.2em] text-white/50 mt-1">
                                    podávať
                                </div>
                            </div>
                        </div>

                        <div className="mt-10 flex flex-wrap gap-4">
                            <a
                                href="mailto:maddrinksss@gmail.com?subject=MAD%20·%20Mám%20záujem&body=Ahoj%2C%0A%0AZaujíma%20ma%20MAD%20Edícia%201.0.%0A%0AMeno%3A%20%0AMesto%3A%20%0A%0AVďaka!"
                                data-testid="hero-cta-primary"
                                className="group inline-flex items-center gap-3 bg-[#D91C1C] hover:bg-white hover:text-black text-white px-8 py-5 text-sm uppercase tracking-[0.2em] font-bold transition-all duration-300 shadow-[0_0_40px_rgba(217,28,28,0.4)] hover:shadow-[0_0_60px_rgba(255,255,255,0.3)]"
                            >
                                Napíš nám
                                <ArrowDownRight
                                    size={18}
                                    className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform"
                                />
                            </a>
                            <a
                                href="#details"
                                data-testid="hero-cta-secondary"
                                className="inline-flex items-center gap-3 border border-white/20 hover:border-white text-white px-8 py-5 text-sm uppercase tracking-[0.2em] font-bold transition-colors"
                            >
                                Čo je vnútri
                            </a>
                        </div>
                    </div>

                    {/* Right: product image */}
                    <div className="col-span-12 lg:col-span-5 fade-up relative">
                        <div className="relative">
                            {/* Glow halo */}
                            <div
                                aria-hidden="true"
                                className="absolute inset-0 -m-12 animate-pulse-glow"
                                style={{
                                    background:
                                        "radial-gradient(circle at center, rgba(217,28,28,0.45) 0%, transparent 60%)",
                                    filter: "blur(40px)",
                                }}
                            />

                            <div className="relative aspect-[3/4] overflow-hidden bg-gradient-to-b from-[#1A0505] via-[#0D0D0D] to-black border border-[#D91C1C]/20">
                                <img
                                    data-testid="hero-product-image"
                                    src={PRODUCT_IMG}
                                    alt="MAD fľaša"
                                    className="absolute inset-0 w-full h-full object-contain p-2 drop-shadow-[0_20px_50px_rgba(217,28,28,0.4)] animate-float transition-transform duration-700 hover:scale-[1.04]"
                                    loading="eager"
                                />

                                {/* Floating Edition badge */}
                                <div className="absolute top-4 left-4 bg-black/70 backdrop-blur border border-white/15 px-3 py-2">
                                    <div className="text-[9px] uppercase tracking-[0.3em] text-white/60">
                                        Edícia
                                    </div>
                                    <div className="font-display text-xl text-white leading-none">
                                        1.0
                                    </div>
                                </div>

                                {/* Floating Vol badge */}
                                <div className="absolute top-4 right-4 bg-[#D91C1C] px-3 py-2">
                                    <div className="text-[9px] uppercase tracking-[0.3em] text-white/80">
                                        Obj
                                    </div>
                                    <div className="font-display text-xl text-white leading-none">
                                        500ml
                                    </div>
                                </div>

                                {/* Bottom signature */}
                                <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black via-black/80 to-transparent">
                                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#D91C1C] mb-1">
                                        Blood Off
                                    </div>
                                    <div className="font-display uppercase text-2xl text-white tracking-tight">
                                        Edícia 1.0
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className="mt-5 text-[11px] uppercase tracking-[0.25em] text-white/40 flex items-center gap-2">
                            <span className="inline-block h-px w-6 bg-white/30" />
                            Vyrobené v kuchyni · Nie v továrni
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
